import moment from "moment";

function isToday(m) {
  return m.isSame(moment(), "day");
}

function isYesterday(m) {
  return m.isSame(moment().add(-1, "d"), "day");
}

export default {
  timestamp(ts, time) {
    if (!ts) return "Undefined Timestamp";
    const m = moment(new Date(ts.seconds * 1000));
    let str = m.format("DD MMM YY");
    if (time) str += " " + m.format("LT");
    return str;
  },
  date(date) {
    const m = moment(date);
    if (!m.isValid()) return "Invalid Date";
    return m.format("DD MMM YY");
  },
  friendlyTime(ts) {
    let m;
    if (typeof ts.getMonth === "function") {
      m = moment(ts);
    } else {
      m = moment(new Date(ts.seconds * 1000));
    }
    const time = m.format("LT");
    if (isToday(m)) {
      return "Today " + time;
    }
    if (isYesterday(m)) {
      return "Yesterday " + time;
    }
    return m.format("DD/MM/YY") + " " + time;
  },
  friendlyTimeShorter(ts) {
    const m = moment(new Date(ts.seconds * 1000));
    const time = m.format("LT");
    if (isToday(m)) {
      return "T.day " + time;
    }
    if (isYesterday(m)) {
      return "Y.day " + time;
    }
    if (moment().diff(m, "d") < 5) {
      return m.format("ddd") + " " + time;
    }
    return m.format("DD/MM/YY") + " " + m.format("A");
  },
  /**
   * Format mobile number to E.164
   * @param n   String  Number
   * @returns {string|*}
   */
  mobileE164(n) {
    /////////////////////////////
    const number = n
      //delete all non-digit except for +
      .replace(/[^\d+]/g, "")
      //replace leading 00
      .replace(/^00/, "+")
      //support incomplete numbers for common mistakes for Australian numbers.
      .replace(/^61/, "+61")
      .replace(/^6104/, "+614")
      //support for Chinese mainland as well.
      .replace(/^86/, "+86");

    if (/^(04|\+614)\d{8}$/.test(number)) {
      return number.replace(/^04/, "+614");
    } else {
      return n;
    }
  },
  mobileDisplay(n) {
    let number = n
      //delete all non-digit except for +
      .replace(/[^\d+]/g, "")
      //replace leading 00
      .replace(/^00/, "+")
      //support incomplete numbers for common mistakes for Australian numbers.
      .replace(/^61/, "+61")
      .replace(/^6104/, "+614")
      //support for Chinese mainland as well.
      .replace(/^86/, "+86");

    if (/^(04|\+614)\d{8}$/.test(number)) {
      number = number.replace(/^04/, "+614");
      return (
        number.substr(0, 3) +
        " " +
        number.substr(3, 3) +
        " " +
        number.substr(6, 3) +
        " " +
        number.substr(9)
      );
    } else {
      return n;
    }
  }
};
